import { Icon } from 'Components';
import { APP_ROUTES } from 'Pages/App/App.constants';
import { LanguageI18nKey } from 'Services/Api/Common/Types';
import { PermissionCode } from 'Services/Api/Users/Types';
import { HELP_DESK_LINK, PUBLIC_RESOURES_URLS } from 'app-config';

export interface NavItemConfig {
	key: string;
	label: string;
	icon?: React.ReactNode;
	isExternal?: boolean;
	path?: string;
	children?: Omit<NavItemConfig, 'children'>[];
}

export const PEAKPORTAL_KEY = 'PeakPortal';

export const mainNavItems: NavItemConfig[] = [
	{
		key: PermissionCode.ViewDashboardOverview,
		label: 'Dashboard',
		icon: <Icon type="dashboardIcon" />,
		path: APP_ROUTES.HOME
	},
	{
		key: PermissionCode.VIEW_MY_COURCES,
		label: 'Courses',
		icon: <Icon type="coursesIcon" />,
		path: APP_ROUTES.COURSES,
	},
	// {
	// 	key: 'training',
	// 	label: 'Training',
	// 	icon: <Icon type="trainingIcon" />,
	// 	children: [
	// 		{
	// 			key: PermissionCode.VIEW_MY_COURCES,
	// 			label: 'My Courses',
	// 			icon: <Icon type="coursesIcon" />,
	// 			path: '/learning-manager',
	// 		},
	// 		{
	// 			key: PermissionCode.VIEW_ASSIGNMENTS,
	// 			label: 'Assignments',
	// 			icon: <Icon type="assignmentsIcon" />,
	// 			path: '/learning-manager/assignments'
	// 		}
	// 	]
	// },
	{
		key: PermissionCode.ViewPhishingManager,
		label: 'Phishing',
		icon: <Icon type="phishingIcon" />,
		path: APP_ROUTES.PHISHING_MANAGER
	},
	{
		key: 'reports',
		label: 'Reports',
		icon: <Icon type="reportsIcon" />,
		children: [
			{
				key: PermissionCode.ViewDashboardPhishing,
				label: 'Phishing',
				icon: <Icon type="phishingMenuIcon" />,
				path: APP_ROUTES.PHISHING
			},
			{
				key: PermissionCode.ViewDashboardElearning,
				label: 'Training',
				icon: <Icon type="trendingArrow" />,
				path: APP_ROUTES.TRAINING
			},
			{
				key: PermissionCode.ViewDashboardSAQCompliance,
				label: 'SAQ Compliance',
				icon: <Icon type="saqMenuIcon" />,
				path: APP_ROUTES.SAQ_COMPLAINCE
			},
			{
				key: PermissionCode.ViewDashboardScanning,
				label: 'Scanning',
				icon: <Icon type="scanningMenuIcon" />,
				path: APP_ROUTES.SCANNING
			},
			{
				key: PermissionCode.ViewDashboardUserActivity,
				label: 'User Activity',
				icon: <Icon type="users" />,
				path: APP_ROUTES.USER_ACTIVITY
			},
			{
				key: PermissionCode.ViewStandardReports,
				label: 'Library',
				icon: <Icon type="libraryMenuIcon" />,
				path: APP_ROUTES.REPORTS
			},
			{
				key: PermissionCode.ViewStandardReports,
				label: 'Saved',
				icon: <Icon type="savedMenuIcon" />,
				path: APP_ROUTES.SAVED_REPORTS
			},
			{
				key: PermissionCode.ViewAuditLog,
				label: 'Audit Logs',
				icon: <Icon type="auditLogMenuIcon" />,
				path: APP_ROUTES.AUDIT_LOG
			}
		]
	},
	{
		key: 'resources',
		label: 'Resources',
		icon: <Icon type="resourceMenuIcon" />,
		children: [
			{
				key: PermissionCode.VIEW_WHITELISTING,
				label: 'Whitelisting',
				icon: <Icon type="whitelistingMenuIcon" />,
				isExternal: true,
				path: PUBLIC_RESOURES_URLS.phising
			},
			{
				key: PermissionCode.VIEW_POLICIES,
				label: 'Policies',
				icon: <Icon type="policiesMenuIcon" />,
				isExternal: true,
				path: PUBLIC_RESOURES_URLS.policytemplates
			}
		]
	},
	{
		key: 'settings',
		label: 'Settings',
		icon: <Icon type="settingsIcon" />,
		children: [
			{
				key: PermissionCode.UserManagerScreenView,
				label: 'Users',
				icon: <Icon type="userMenuIcon" />,
				path: APP_ROUTES.USERS
			},
			{
				key: PermissionCode.ViewGroups,
				label: 'Groups',
				icon: <Icon type="users" />,
				path: APP_ROUTES.GROUPS_LANDING
			},
			{
				key: PermissionCode.ViewOwnershipGroups,
				label: 'Ownership',
				icon: <Icon type="ownerShipMenuIcon" />,
				path: APP_ROUTES.OWNERSHIP_GROUPS_LANDING
			},
			{
				key: PermissionCode.ViewRoles,
				label: 'Roles',
				icon: <Icon type="roleMenuIcon" />,
				path: APP_ROUTES.ROLES
			},
			{
				key: PermissionCode.ViewMappingTenant,
				label: 'Mapping',
				icon: <Icon type="mappingMenuIcon" />,
				path: APP_ROUTES.MAPPING
			}
		]
	}
];

export const bottomNavItems: NavItemConfig[] = [
	{
		key: 'language',
		label: 'English',
		icon: <Icon type="languageIcon" />,
		children: [
			{ key: LanguageI18nKey.English, label: "English", path: LanguageI18nKey.English }, 
			// { key: LanguageI18nKey.French, label: "French", path: LanguageI18nKey.French }
		]
	},
	{
		key: 'help',
		label: 'Help',
		icon: <Icon type="helpIcon" />,
		isExternal: true,
		path: HELP_DESK_LINK
	}
];

export const accountItems: NavItemConfig[] = [
	{
		key: 'profile',
		label: 'Account Settings',
		icon: <Icon type="profileMenuIcon" />,
		path: APP_ROUTES.PROFILE
	},
	{
		key: 'logout',
		label: 'Sign Out',
		icon: <Icon type="logoutMenuIcon" />,
		path: APP_ROUTES.LOGOUT
	}
];

export const GET_MENU_NAME_BY_SUBMENU : Record<string, string> = {
	'groups-new': APP_ROUTES.GROUPS_LANDING,
	'groups-deleted': APP_ROUTES.GROUPS_LANDING,
	'groups': APP_ROUTES.GROUPS_LANDING,
	'groups-hierarchy': APP_ROUTES.GROUPS_LANDING,
	'tenants': APP_ROUTES.GROUPS_LANDING,
	'ownership-groups-new': APP_ROUTES.OWNERSHIP_GROUPS_LANDING,
	'ownership-groups': APP_ROUTES.OWNERSHIP_GROUPS_LANDING
}